import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CheckboxCell from "../../../common/interactive/CheckboxCell";
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel";
import InputBox from "../../../common/interactive/InputBox";
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import CustomSelect from "../../../common/interactive/CustomSelect";
import { serviceAlreadyexistsOnOtherMajorMeds } from "../../../../lib/script";
import { frontendOptions } from "../../../../lib/systemData";

import classes from './MajorMedDepartment.module.css'

export default function MajorMedDepartmentDrawerServiceItem({serviceItem, departmentId, majorMedData}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    const [majorMedDepartmentServiceItem, setMjorMedDepartmentServiceItem] = useState(null)
    const [itemIsDisabled, setItemIsDisabled] = useState(false)

    const [noStatusAuthExpDate, setNoStatusAuthExpDate] = useState(true)
    const statusOptionsData = useMemo(() => frontendOptions()?.statusOptions || [], [])
    
    useEffect(() => {
        if (majorMedData.major_med_departments) {
          
            let specificDepartment = majorMedData.major_med_departments.find(item => item.department_id == departmentId)

            if (specificDepartment && specificDepartment.services && specificDepartment.services.length > 0 && specificDepartment.services.find(item => item.service_id == serviceItem.id)) {      

                setMjorMedDepartmentServiceItem(specificDepartment.services.find(item => item.service_id == serviceItem.id))
                setNoStatusAuthExpDate(false)
            } else {
                setMjorMedDepartmentServiceItem(null)
                setNoStatusAuthExpDate(true)
            }
        }

        setItemIsDisabled(serviceAlreadyexistsOnOtherMajorMeds(majorMedData.id, activeCase, departmentId, serviceItem.id))
        
        
    }, [activeCase, majorMedData.major_med_departments, departmentId])

    const updateHandler = async (data) => {
        let specificDepartment = majorMedData.major_med_departments.find(item => item.department_id == departmentId)

        if (!specificDepartment) { // create department
            let departmentreqBody = {
                type: 'case_major_med_departments',
                type_id: data.identifier.type_id, // same as below
                fields: {
                    department_id: departmentId,
                }
            }
    
            let update = await caseQuickUpdate(userToken, activeCase.case.id, departmentreqBody)
    
            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {            
    
                let dispatchObj = {
                    folder: data.identifier.folder,
                    itemId: data.identifier.type_id,
                    departmentId: data.identifier.department_id,
                    data: update
                }
        
        
                dispatch(caseActions.setDepartmentOnMajorMed(dispatchObj))
            } 
        } 
  
        // then continue with the rest of the logic.
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                department_id: data.identifier.department_id,
                service_id: data.identifier.service_id,
                [data.identifier.field] : data.data.value,
            }
        }

        if (data.identifier.field == 'auth_number' || data.identifier.field == 'auth_date') { // if auth number or auth date change the status in approved
            reqBody.fields.status_id = 1
        }    

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {  

            let dispatchObj = {
                folder: data.identifier.folder,
                itemId: data.identifier.type_id,
                departmentId: data.identifier.department_id,
                serviceId: data.identifier.service_id,
                data: update
            }
    
   
            dispatch(caseActions.setServiceOnMajorMed(dispatchObj))
        }        
        
    }


    return <tr className={`${itemIsDisabled ? classes.item_disabled : ''}`}>                        
        <td>{serviceItem.description}</td>
        {(departmentId == 1 || departmentId == 2) && <td >
            <InputBox currentValue={majorMedDepartmentServiceItem?.no_visits} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'no_visits', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}}/>
        </td>}
        <td className="table-cell-no-padding">
            <CustomSelect optionsData={statusOptionsData} preSelectedValue={majorMedDepartmentServiceItem?.status_id} action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'status_id', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} sameSizeAsContainer={true}/>
        </td>
        <td>
            <InputBox  currentValue={majorMedDepartmentServiceItem?.auth_number} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'auth_number', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}}/>
        </td>
        <td>
            <DatepickerWithLabel textRight={true} defaultDate={majorMedDepartmentServiceItem?.auth_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'auth_date', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}}/>
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentServiceItem?.final_verification_completed} action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'final_verification_completed', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} setStyle={'centered'}/>
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentServiceItem?.copay_coins} action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'copay_coins', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} setStyle={'centered'}/>
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <InputBoxCurrency textRight={true} currentValue={majorMedDepartmentServiceItem?.deductibles} name={'deductibles'} action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'deductibles', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} />
        </td>
        <td  className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentServiceItem?.paid}  action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'paid', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} setStyle={'centered'}/>
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentServiceItem?.payment_plan}  action={updateHandler} identifier={{type: 'case_major_med_department_services', field: 'payment_plan', type_id: majorMedData.id, department_id: departmentId, service_id: serviceItem.id, folder: 'major_meds'}} setStyle={'centered'}/>
        </td>
    </tr>
}